import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import { clearAffiliateAuth } from "../helper/authSession";

const initialState = {
    isLoggedIn: false,
    affiliate: {},
    data: null,
    errorMsg: "",
    isError: false,
    affiliatetoken: null,
    profileFetchStatus: "idle",
}

export const AffiliategetProfile = createAsyncThunk('AffiliategetProfile', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.AffiliategetProfile();

        if (status === 200) {
            dispatch(setLoginData(data.data))
            return data.data
        }
    } catch (err) {
        const status = err.response?.status;
        if (status === 401 || status === 403) {
            clearAffiliateAuth();
        }
        return rejectWithValue(
            err.response?.data?.message || "'Something went wrong. Please try again later.'"
        )
    }
}
)



// Add this thunk for fetching webinars
export const getWebinarsWithoutParamsAffiliate = createAsyncThunk('getWebinarsWithoutParamsAffiliate', async (body, { rejectWithValue, dispatch }) => {
  try {
    const { data, status } = await api.getWebinarsAffiliate();
    console.log(data, "Webinar data");
    
    if (status === 200) {
      return data.data;
    }
    return data.data;
  } catch (err) {
    return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
  }
});

export const getCoursesWithoutParamsAffiliate = createAsyncThunk('getCoursesWithoutParamsAffiliate', async (body, { rejectWithValue, dispatch }) => {
    try {

        // const queryParams = new URLSearchParams(body).toString();
        const { data, status } = await api.getCoursesAffiliate();
        console.log(data,"daaatatatata courssee");
        
        if (status === 200) {
            //get categories data
            // dispatch(setCoursesWithoutParams(data.data))

        }
        return data.data
    } catch (err) {
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)


export const  getUrlsForAffiliate = createAsyncThunk('getUrlsForAffiliate', async (body, { rejectWithValue, dispatch })=>{
    try {
        const {data,status} = await api.generateLink(body)

        if (status === 200) {
            //get categories data
            // dispatch(setCoursesWithoutParams(data.data))

        }
        return data.data
        
    } catch (err) {
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")

    }
})


const affiliateSlice = createSlice({
    name: "affiliate",
    initialState,
    reducers: {
        setLogin: (state, action) => {
            state.isLoggedIn = true
            state.affiliate = action.payload
        },
        // setTwoFA: (state, action) => {
        //     state.user["2FA"] = action.payload
        // },
        setLogOut: (state, action) => {
            state.isLoggedIn = false
            state.affiliate = {}
            state.affiliatetoken = ""
            state.profileFetchStatus = "idle"
            state.data = null
        },
        setLoginData: (state, action) => {
            state.data = action.payload
        },
        setToken: (state, action) => {
            state.affiliatetoken = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(AffiliategetProfile.pending, (state) => {
            state.profileFetchStatus = "loading"
            state.isError = false
        })
        builder.addCase(AffiliategetProfile.fulfilled, (state, action) => {
            state.profileFetchStatus = "succeeded"
            state.isLoggedIn = true
            state.affiliate = action.payload
            state.errorMsg = ""
        })
        builder.addCase(AffiliategetProfile.rejected, (state, action) => {
            state.profileFetchStatus = "failed"
            state.isLoggedIn = false
            state.affiliate = {}
            state.data = null
            state.affiliatetoken = ""
            state.errorMsg = action.payload
        })
    }
})

export const { setLogin, setTwoFA, setLogOut, setLoginData, setToken } = affiliateSlice.actions

export default affiliateSlice.reducer;